const capitalize = str => {
  // capitlize first letter of string
  let res;
  res = str.replace(/^\w/, function(chr) {
    return chr.toUpperCase();
  });
  return res;
};
export default capitalize;



// WEBPACK FOOTER //
// ./src/helpers/capitalize.js